var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "nav-meta__list-item-link",
      attrs: { href: "javascript:void(0)" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.onCartOpen.apply(null, arguments)
        }
      }
    },
    [
      !_vm.hasBasket
        ? _c("span", {
            staticClass: "nav-meta__list-item-text",
            domProps: { innerHTML: _vm._s(_vm.$t("cart.iconLabel")) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("SVGBag", { staticClass: "nav-meta__list-item-icon" }),
      _vm._v(" "),
      _vm.totalItemsWithoutAdditional
        ? _c("span", {
            staticClass: "nav-meta__list-item-count",
            domProps: { innerHTML: _vm._s(_vm.totalItemsWithoutAdditional) }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }